<template>
  <div>
    <el-select v-model="currentSelect">
      <el-option
          v-for="item in list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
      />
    </el-select>
    <template v-if="currentItem">
      <el-select class="ml-4" v-model="currentItem.setting.isLandscape" @change="onChange">
        <el-option label="开启" :value="true" />
        <el-option label="关闭" :value="false" />
      </el-select>
    </template>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { transformRichText2Text } from '@dygc/question'
import { update } from '@/question/operate'

export default {
  name: 'Landscape',
  data() {
    return {
      currentSelect: ''
    }
  },
  computed: {
    list() {
      return this.questionList.map(item => {
        return {
          value: item.id,
          label: transformRichText2Text(item.content.richText)
        }
      })
    },
    currentItem() {
      const id = this.currentSelect
      return this.questionList.find(item => item.id === id)
    },
    ...mapGetters(['questionList'])
  },
  methods:{
    onChange(){
      update(this.currentItem)
    }
  }
}
</script>

<style scoped>

</style>